<template>
  <div
    style="overflow: scroll;cursor: pointer;"
    class="side-categories__wrapper d-none d-lg-block">
    <div class="side-categories">
      <!-- ログインしているユーザー情報 -->
      <sidebar-login-user-tab />
      <!-- カテゴリ情報 -->
      <CategoryMenuForPC />
      <div
        class="side-categories__today">
        <today-button
          xl
          :active="!isDisplayDetail"
          @click="onClickTodayButton">
          {{ isDisplayDetail ? '全体表示' : '詳細表示' }}
        </today-button>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarLoginUserTab from '@/components/view/SidebarLoginUserTab'
import CategoryMenuForPC from '@/components/view/CategoryMenuForPC.vue'
import TodayButton from '@/components/parts/TodayButton'
import { mapState } from 'vuex'
export default {
  components: {
    SidebarLoginUserTab,
    CategoryMenuForPC,
    TodayButton
  },
  computed: {
    ...mapState('events', ['isDisplayDetail']),
  },
  methods: {
    onClickTodayButton() {
      const newIsDisplayDetail = !this.isDisplayDetail
      this.$store.commit('events/setIsDisplayDetail', newIsDisplayDetail)

      // 全体 -> 詳細表示の時
      if (newIsDisplayDetail) {
        this.$store.commit('events/setSelectedDate', new Date())
        this.$store.commit('events/setShouldScrollToToday', true)
        return
      }

      // 詳細 -> 全体表示の時
      this.$store.commit('events/setShouldScrollToTop', true)
    },
  }

}
</script>

<style lang="scss" scoped>
.side-categories__wrapper {
  width: 302px;
  min-width: 302px;
}

.side-categories {
  background-color: $white;
  width: 302px;
  height: 100vh;
  position: fixed;
  top: 0;

  &__today {
    z-index: 9999;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>